import getCookie, { COOKIE_MH_TOKEN } from '../../../common/cookies';
import environment from '../../../common/environment';
import { getResponseData } from '../../../common/utils/api-utils';
import { AccessCodeDetails } from '../interfaces/access-code.interface';

/*----- HELPERS -----*/
export async function getAccessCodeApiCall(code: string): Promise<AccessCodeDetails> {
  const url = `${environment().searchServiceUrl}/accesscode/${code}`;
  return await getResponseData(
    new Request(url.toString(), {
      method: 'GET',
      headers: { 'Content-Type': 'application/json' }
    })
  );
}

export async function redeemAccessCodeApiCall(code: string): Promise<unknown> {
  const token = getCookie(COOKIE_MH_TOKEN);
  const url = `${environment().rmsUrl}/v2/coupons/${code}/adopt`;
  return await getResponseData(
    new Request(url.toString(), {
      method: 'POST',
      credentials: 'include',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token}`
      },
      body: JSON.stringify({ accessCode: code })
    })
  );
}

